module.exports = __webpack_public_path__ + "static/recipe.ba315e4e.png";